import React, { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TYPES } from 'store/modules/app/actions';
import { getIsShowingModal } from 'store/modules/app/selectors';
import { Button } from '../Button/Button';

interface Props {
  modalHeader: ReactNode,
  children?: ReactNode,
  onModalClose?: () => void;
}

export const Modal = (props: Props) => {
  const {
    modalHeader,
    children,
    onModalClose,
  } = props;

  const dispatch = useDispatch();
  const isShowingModal = useSelector(getIsShowingModal);

  useEffect(() => {
    const body = document.querySelector('body');

    if (!body) {
      return;
    }

    if (isShowingModal) {
      body.classList.add('modal-is-open');
      return;
    }

    body.classList.remove('modal-is-open');
  }, [isShowingModal, onModalClose]);


  if (!isShowingModal) {
    return null;
  }

  const closeModal = () => {
    dispatch({ type: TYPES.HIDE_MODAL });

    if (onModalClose) {
      onModalClose();
    }
  };

  return (
    <div className="Modal-wrapper">
      <div className="Modal">
        <div className="Modal-header">
          {modalHeader}

          <Button
            label="close"
            icon="ic-close"
            onClick={closeModal}
            className="Button Modal-close"
            isIconOnly
          />
        </div>

        {children && (
          <div className="Modal-body">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};
